import { compile } from 'path-to-regexp';
/**
 * @class RoutePath
 * @since 1.0.0
 * @hidden
 */
export class RoutePath {
    //--------------------------------------------------------------------------
    // Methods
    //--------------------------------------------------------------------------
    /**
     * @constructor
     * @since 1.0.0
     */
    constructor(route) {
        this.route = route;
        this.generator = compile(route);
    }
    /**
     * @method retrieve
     * @since 1.0.0
     */
    retrieve(opts) {
        return this.route;
    }
    /**
     * @method generate
     * @since 1.0.0
     */
    generate(keys, opts) {
        return this.generator(keys);
    }
}
